import { FinanceRate } from '@kanda-libs/ks-frontend-services';
import { useMemo } from 'react';
import { groupByAprAndType, GroupedByAprAndType } from 'utils';
import { PLACEHOLDER_RATES } from './constants';
import { sortFinanceRateKeys } from './helpers';

export interface LayoutSidebarFinanceRatesHook {
  formattedFinanceRates?: GroupedByAprAndType;
  sortedKeys: string[];
  show: boolean;
}

export default function useLayoutSidebarFinanceRates(
  rates?: FinanceRate[],
  isLoading = false,
): LayoutSidebarFinanceRatesHook {
  const formattedFinanceRates = useMemo(() => {
    if (isLoading) return groupByAprAndType(PLACEHOLDER_RATES);
    if (!rates) return undefined;
    return groupByAprAndType(rates);
  }, [rates, isLoading]);

  const sortedKeys = useMemo(() => {
    if (!formattedFinanceRates) return [];
    return sortFinanceRateKeys(formattedFinanceRates);
  }, [formattedFinanceRates]);

  const show = useMemo(() => {
    if (isLoading) return true;
    if (!rates) return false;
    return rates.length > 0;
  }, [isLoading, rates]);

  return {
    formattedFinanceRates,
    sortedKeys,
    show,
  };
}
